// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================================
   Customer Quote Requests — Styles
   ========================================================================= */

/* Tabs */
.cqr-tabs .nav-link {
  color: #666;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-right: 6px;
  transition: all 0.2s ease;
}
.cqr-tabs .nav-link.active {
  background: #ff385c;
  color: #fff;
}
.cqr-tabs .nav-link:hover:not(.active) {
  background: #fff0f2;
  color: #ff385c;
}

/* Request Cards */
.cqr-request-card {
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.cqr-request-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.cqr-card-desc {
  color: #1c1c1c;
  font-size: 0.95rem;
  line-height: 1.4;
}
.cqr-card-meta {
  font-size: 0.78rem;
  color: #93959f;
}
.cqr-card-meta i {
  color: #b0b3b8;
}
.cqr-card-budget {
  background: #f0faf3;
  color: #1b9e3e;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
}
.cqr-category-badge {
  background: #f0f0ff;
  color: #5b5fc7;
  font-weight: 600;
  font-size: 0.72rem;
  border-radius: 6px;
  padding: 4px 10px;
}

/* Quote Cards */
.cqr-quote-card {
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: transform 0.15s ease;
}
.cqr-quote-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.cqr-quote-price {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1c1c1c;
}

/* Notification Cards */
.cqr-notif-card {
  border-radius: 8px;
  border: none;
  transition: background 0.2s;
}
.cqr-notif-unread {
  background: #fff8f9;
  border-left: 3px solid #ff385c;
}
.cqr-notif-read {
  background: #f8f8f8;
  border-left: 3px solid transparent;
}

/* Toast */
.cqr-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 24px;
  color: #fff;
  border-radius: 8px;
  font-size: 0.88rem;
  z-index: 10000;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.cqr-toast.show {
  opacity: 1;
  transform: translateY(0);
}

/* Create Button */
.cqr-create-btn {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  font-size: 0.92rem;
}
.cqr-create-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 56, 92, 0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .cqr-quote-price {
    font-size: 1.3rem;
  }
  .cqr-tabs .nav-link {
    font-size: 0.78rem;
    padding: 5px 12px;
  }
}

/* Map Trigger */
.cqr-map-trigger {
  border-color: #ced4da !important;
  color: #ff385c !important;
}

.cqr-map-trigger:hover {
  background-color: #ff385c !important;
  color: white !important;
  border-color: #ff385c !important;
}

.cqr-cancel-request {
  color: #93959f;
  font-size: 0.72rem;
  font-weight: 500;
  text-decoration: none !important;
  padding: 4px 10px;
  border-radius: 20px;
  background: #f4f4f5;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
}

.cqr-cancel-request:hover {
  color: #ff385c;
  background: #fff0f2;
}

.cqr-cancel-request i {
  font-size: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/css/customerQuoteRequests.css"],"names":[],"mappings":"AAAA;;8EAE8E;;AAE9E,SAAS;AACT;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,uDAAuD;EACvD,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* =========================================================================\r\n   Customer Quote Requests — Styles\r\n   ========================================================================= */\r\n\r\n/* Tabs */\r\n.cqr-tabs .nav-link {\r\n  color: #666;\r\n  border-radius: 20px;\r\n  padding: 6px 16px;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  margin-right: 6px;\r\n  transition: all 0.2s ease;\r\n}\r\n.cqr-tabs .nav-link.active {\r\n  background: #ff385c;\r\n  color: #fff;\r\n}\r\n.cqr-tabs .nav-link:hover:not(.active) {\r\n  background: #fff0f2;\r\n  color: #ff385c;\r\n}\r\n\r\n/* Request Cards */\r\n.cqr-request-card {\r\n  border-radius: 12px;\r\n  border: 1px solid #f0f0f0;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n.cqr-request-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n}\r\n.cqr-card-desc {\r\n  color: #1c1c1c;\r\n  font-size: 0.95rem;\r\n  line-height: 1.4;\r\n}\r\n.cqr-card-meta {\r\n  font-size: 0.78rem;\r\n  color: #93959f;\r\n}\r\n.cqr-card-meta i {\r\n  color: #b0b3b8;\r\n}\r\n.cqr-card-budget {\r\n  background: #f0faf3;\r\n  color: #1b9e3e;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n}\r\n.cqr-category-badge {\r\n  background: #f0f0ff;\r\n  color: #5b5fc7;\r\n  font-weight: 600;\r\n  font-size: 0.72rem;\r\n  border-radius: 6px;\r\n  padding: 4px 10px;\r\n}\r\n\r\n/* Quote Cards */\r\n.cqr-quote-card {\r\n  border-radius: 12px;\r\n  border: 1px solid #f0f0f0;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n  transition: transform 0.15s ease;\r\n}\r\n.cqr-quote-card:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n}\r\n.cqr-quote-price {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #1c1c1c;\r\n}\r\n\r\n/* Notification Cards */\r\n.cqr-notif-card {\r\n  border-radius: 8px;\r\n  border: none;\r\n  transition: background 0.2s;\r\n}\r\n.cqr-notif-unread {\r\n  background: #fff8f9;\r\n  border-left: 3px solid #ff385c;\r\n}\r\n.cqr-notif-read {\r\n  background: #f8f8f8;\r\n  border-left: 3px solid transparent;\r\n}\r\n\r\n/* Toast */\r\n.cqr-toast {\r\n  position: fixed;\r\n  top: 20px;\r\n  right: 20px;\r\n  padding: 12px 24px;\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  font-size: 0.88rem;\r\n  z-index: 10000;\r\n  opacity: 0;\r\n  transform: translateY(-10px);\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n.cqr-toast.show {\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n}\r\n\r\n/* Create Button */\r\n.cqr-create-btn {\r\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\r\n  font-size: 0.92rem;\r\n}\r\n.cqr-create-btn:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(255, 56, 92, 0.3);\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .cqr-quote-price {\r\n    font-size: 1.3rem;\r\n  }\r\n  .cqr-tabs .nav-link {\r\n    font-size: 0.78rem;\r\n    padding: 5px 12px;\r\n  }\r\n}\r\n\r\n/* Map Trigger */\r\n.cqr-map-trigger {\r\n  border-color: #ced4da !important;\r\n  color: #ff385c !important;\r\n}\r\n\r\n.cqr-map-trigger:hover {\r\n  background-color: #ff385c !important;\r\n  color: white !important;\r\n  border-color: #ff385c !important;\r\n}\r\n\r\n.cqr-cancel-request {\r\n  color: #93959f;\r\n  font-size: 0.72rem;\r\n  font-weight: 500;\r\n  text-decoration: none !important;\r\n  padding: 4px 10px;\r\n  border-radius: 20px;\r\n  background: #f4f4f5;\r\n  transition: all 0.2s;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.cqr-cancel-request:hover {\r\n  color: #ff385c;\r\n  background: #fff0f2;\r\n}\r\n\r\n.cqr-cancel-request i {\r\n  font-size: 0.8rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
